// app/providers.tsx
"use client";
import { client } from "@/client/client.gen";
import posthog from "posthog-js";

if (typeof window !== "undefined") {
  client.setConfig({
    // set default base url for requests
    withCredentials: true,
    baseURL: window.location.origin,
  });
  client.instance.interceptors.request.use((config) => {
    const access_token =
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("access_token="))
        ?.split("=")[1] || "";
    config.headers.set("Authorization", `Bearer ${access_token}`);
    const sessionId = posthog.get_session_id();
    if (sessionId) {
      config.headers.set("x-posthog-session-id", sessionId);
    }
    return config;
  });
  client.instance.interceptors.response.use(
    (response) => response,
    (error) => {
      return Promise.reject(error);
    },
  );
}

export function BackendClientProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
